"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var To2To = require("to2to");
var To = /** @class */ (function (_super) {
    __extends(To, _super);
    function To() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.to = null;
        return _this;
    }
    To.prototype.receiveProps = function (props, data, preProps) {
        var _this = this;
        var restart = false;
        for (var key in props.from) {
            if (props.from[key] !== preProps.from[key]) {
                restart = true;
                break;
            }
        }
        if (!restart) {
            for (var key in props.to) {
                if (props.to[key] !== preProps.to[key]) {
                    restart = true;
                    break;
                }
            }
        }
        if (restart || props.start && !preProps.start) {
            if (this.to)
                this.to.stop();
            this.to = To2To.get(props.from)
                .wait(props.delay || 0)
                .to(props.to, props.duration, To2To.easing[npn(props.easing || 'linear')])
                .begin(function () {
                _this.fire('begin');
            })
                .progress(function (obj) {
                //@ts-ignore
                Object.assign(props.out, obj);
                _this.fire('progress');
            })
                .end(function () {
                _this.fire('end');
            })
                .start();
        }
    };
    To.prototype.installed = function () {
        if (this.props.start) {
            this.receiveProps(this.props, null, { from: {}, to: {} });
        }
    };
    To.prototype.render = function () {
        return (omi_1.h("slot", null));
    };
    To.propTypes = {
        from: Object,
        to: Object,
        duration: Number,
        out: Object,
        easing: String,
        delay: Number
    };
    To = __decorate([
        omi_1.tag('m-to')
    ], To);
    return To;
}(omi_1.WeElement));
exports.default = To;
function npn(str) {
    return str.replace(/-(\w)/g, function ($, $1) {
        return $1.toUpperCase();
    });
}
